module.exports = __webpack_public_path__ + "static/media/EarPeaceLogo.a6ad04ec.png";